var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoMobile = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6759_41526)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4615 1.8335H5.53846C4.68923 1.8335 4 2.51228 4 3.34865V13.6517C4 14.488 4.68923 15.1668 5.53846 15.1668H10.4615C11.3108 15.1668 12 14.488 12 13.6517V3.34865C12 2.51228 11.3108 1.8335 10.4615 1.8335ZM8 14.5608C7.48923 14.5608 7.07692 14.1547 7.07692 13.6517C7.07692 13.1486 7.48923 12.7426 8 12.7426C8.51077 12.7426 8.92308 13.1486 8.92308 13.6517C8.92308 14.1547 8.51077 14.5608 8 14.5608ZM10.7692 12.1365H5.23077V3.65168H10.7692V12.1365Z",
    fill: "#8D939C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6759_41526"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#fff",
    transform: "translate(0 .5)"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoMobile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_mobile.0239259a96582fe6006c8843cbf821ad.svg";